import { render } from "./RestaurantAdmin.vue?vue&type=template&id=b69da9d6&scoped=true&ts=true"
import script from "./RestaurantAdmin.vue?vue&type=script&lang=ts"
export * from "./RestaurantAdmin.vue?vue&type=script&lang=ts"

import "./RestaurantAdmin.vue?vue&type=style&index=0&id=b69da9d6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b69da9d6"]])

export default __exports__